"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCareNoteMock;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
function createCareNoteMock(_ref) {
  var resolve = _ref.resolve;
  setTimeout(function () {
    resolve();
  }, 1000);
}
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(createCareNoteMock, "createCareNoteMock", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/mock/create-care-note.mock.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVDYXJlTm90ZU1vY2siLCJyZXNvbHZlIiwic2V0VGltZW91dCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZXJ2aWNlcy9tb2NrL2NyZWF0ZS1jYXJlLW5vdGUubW9jay5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVDYXJlTm90ZU1vY2soeyByZXNvbHZlIH0pIHtcblx0c2V0VGltZW91dCgoKSA9PiB7XG5cdFx0cmVzb2x2ZSgpO1xuXHR9LCAxMDAwKTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFlLFNBQVNBLGtCQUFrQixPQUFjO0VBQUEsSUFBWEMsT0FBTyxRQUFQQSxPQUFPO0VBQ25EQyxVQUFVLENBQUMsWUFBTTtJQUNoQkQsT0FBTyxFQUFFO0VBQ1YsQ0FBQyxFQUFFLElBQUksQ0FBQztBQUNUO0FBQUM7QUFBQTtFQUFBO0VBQUE7SUFBQTtFQUFBO0VBQUEsd0JBSnVCRCxrQkFBa0I7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==